/***************************************** Slideshow *****************************/

// slideshow
new Swiper("#productV2Swiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '#productV2SwiperRight',
        prevEl: '#productV2SwiperLeft',
    },
    on: {
        slideChange: function () {
            document.querySelector('#productV2SwiperIndex span').innerHTML = this.realIndex + 1;
        }
    }
})

/***************************************** FAQ Slider *****************************/

// setup reviews swipers for all faq items that contain it
let reviewSwipers = document.querySelectorAll('.productV2SliderReviews.swiper');
reviewSwipers.forEach(swiper => {
    new Swiper(swiper, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        breakpoints: {
            801: {
                spaceBetween: 20
            }
        }
    })
})

// needed FAQ variables
const FAQs = document.querySelectorAll('.productV2SliderContentItem');
// get the buttons
let nextBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationNext`);
let prevBtn = document.querySelector(`#productV2Slider .productV2SliderNavigationPrev`);

// open slider on 'learn more' click
document.querySelector('#productV2FAQ').addEventListener('click', function () {
    let sliderFaqs = document.querySelectorAll('.productV2SliderContentItem');
    let foundActive = [...sliderFaqs].some(faq => faq.classList.contains('active'))
    // show the first element if there was no active one before
    !foundActive ? document.querySelector('.productV2SliderContentItem').classList.add('active') : '';

    // call the open slider function
    openSlider();
})

/*
// update nav buttons
function updateNavButtons() {
    // needed nav variables
    let isBeginning = false;
    let isEnding = false;
    let type = document.querySelector('.productV2SliderContentItem.active').dataset.id;

    // check if this is the beginning of the questions
    FAQs.forEach((faq, index) => {
        if (faq.dataset.id === type) {
            faq.dataset.id = type;
            if (index === 0) {
                isBeginning = true;
            } else if (index === FAQs.length - 1) {
                isEnding = true;
            }
        }
    })

    // check if this is the start or end
    isBeginning === true ? prevBtn.classList.add('disabled') : prevBtn.classList.remove('disabled');
    isEnding === true ? nextBtn.classList.add('disabled') : nextBtn.classList.remove('disabled');
}
 */

// make next question active
nextBtn.onclick = () => {
    helperFunction(true)
};
prevBtn.onclick = () => {
    helperFunction(false)
};

// helper function for faqs slider nav
function helperFunction(goNext) {
    // needed variables
    let targetEl = "";
    let currentEl = document.querySelector('.productV2SliderContentItem.active');
    let currentIndex = "";
    let numEls = document.querySelectorAll('.productV2SliderContentItem');

    // get the current index
    numEls.forEach((el, index) => {
        if (el.classList.contains('active')) {
            currentIndex = index;
        }
    })

    // no element? exit
    if (!currentEl || numEls.length === 1) {
        return;
    }

    if (currentIndex === numEls.length - 1 && goNext === true) {
        // loop to start if at end
        targetEl = numEls[0];
    } else if (currentIndex === 0 && goNext === false) {
        // loop to end if at start
        targetEl = numEls[numEls.length - 1];
    } else {
        // determine if we need next or previous sibling
        targetEl = goNext === true ? currentEl.nextElementSibling : currentEl.previousElementSibling;
    }
    if (targetEl != null) {
        currentEl?.classList.remove('active');
        targetEl?.classList.add('active');

        // update the dropdown to match the active faq
        let dropdownItem = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`);
        if (dropdownItem) {
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = document.querySelector(`.productV2SliderDropdownContainerItem[data-id="${targetEl.dataset.id}"]`)?.innerHTML;
            document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
                element.classList.remove("hidden");
                if (element.dataset.id === targetEl.dataset.id) {
                    element.classList.add("hidden");
                }
            });
        }
    }

    // scroll to top of slider content
    document.querySelector('#productV2SliderContent')?.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// open faqs dropdown nav on click
document.querySelector('#productV2SliderDropdownButton').addEventListener('click', function () {
    this.classList.toggle('active');
})

// change faq on dropdown select
document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(item => {
    item.addEventListener('click', function () {
        // change active faq
        document.querySelectorAll('.productV2SliderContentItem').forEach(faq => faq.classList.remove('active'));
        document.querySelector(`.productV2SliderContentItem[data-id="${this.dataset.id}"]`).classList.add('active');

        // show any hidden items in the dropdown from previous selection
        document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => element.classList.remove('hidden'));

        // hide the item in the dropdown that is currently selected
        this.classList.add('hidden')

        // change dropdown label
        // document.querySelector('#productV2SliderDropdownButton span').innerHTML = this.innerHTML;

        // close dropdown
        document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

        // scroll to top of slider content
        document.querySelector('#productV2SliderContent')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
});

// close slider on click
document.querySelector('#productV2SliderClose').addEventListener('click', function () {
    closeSlider();
})

/***************************************** End FAQ Slider *****************************/


// show hide the buy now button
window.addEventListener('scroll', function () {
    if (document.querySelector("#productV2ATC").getBoundingClientRect().top < 0) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();

    // scroll to top on desktop, otherwise scroll to title
    if (window.innerWidth > 800) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else {
        // scroll to the title which is essential the height of the productSwiper
        window.scrollTo({
            top: document.querySelector("#productV2Swiper").clientHeight - 60,
            behavior: 'smooth'
        });
    }
});

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productV2FormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        document.querySelectorAll(".productV2FormRowParent").forEach(item => item.classList.remove('active'));

        // sync action across all forms
        document.querySelectorAll(`.productV2FormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            // update atc lang
            refreshForm();

            // add active class to the parent
            element.closest(".productV2FormRowParent").classList.add('active');
        })
    });
})

/***************************************** FAQs *****************************/

document.querySelectorAll(".productV2FAQItemButton").forEach(button => {
    button.addEventListener("click", function () {
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }
        // remove active from all other faqs
        document.querySelectorAll(".productV2FAQItemButton").forEach(item => item.classList.remove("active"));
        this.classList.add("active");
    })
})


/***************************************** Slider Popup *****************************/

const slider = document.querySelector("#productV2Slider");

function openSlider() {
    // open slider modal
    slider.showModal();

    // update the dropdown to match the active faq
    let activeFAQ = document.querySelector('.productV2SliderContentItem.active').dataset.id;
    document.querySelectorAll('.productV2SliderDropdownContainerItem').forEach(element => {
        element.classList.remove("hidden");
        if (element.dataset.id === activeFAQ) {
            element.classList.add("hidden");
            // document.querySelector('#productV2SliderDropdownButton span').innerHTML = element.innerHTML;
        }
    });

    // no scroll on body
    document.querySelector('body').classList.add('noScroll');
}

function closeSlider() {
    // close modal
    slider.close();

    // close dropdown if open
    document.querySelector('#productV2SliderDropdownButton').classList.remove('active');

    // remove no scroll
    document.querySelector('body').classList.remove('noScroll');
}


let dropdown = document.querySelector('#productV2SliderDropdown');
// modal close and/or dropdown close on outside click
slider.addEventListener('click', function (e) {
    if (e.target === this) {
        closeSlider();
    }
    if (!dropdown.contains(e.target)) {
        dropdown.querySelector('button').classList.contains('active') ? dropdown.querySelector('button').classList.remove('active') : "";
    }
})

// accessibility close
slider.addEventListener('close', function () {
    closeSlider();
})

// function for generating stars
function stars(rating) {
    let HTML = "";

    // add full stars
    for (let i = 0; i < Math.floor(rating); i++) {
        HTML += `<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.13868 0L11.0948 6.02046L17.4251 6.02046L12.3038 9.74131L14.26 15.7618L9.13868 12.0409L4.01737 15.7618L5.97353 9.74131L0.852221 6.02046L7.18251 6.02046L9.13868 0Z" fill="#1758FF"/>
</svg>
`;
    }

    // add empty stars
    for (let i = 0; i < 5 - Math.ceil(rating); i++) {
        HTML += `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2.79 3.4 18.42 17.67"><path d="M6.50929 19.3369C6.45781 19.637 6.58119 19.9404 6.82754 20.1193C7.0739 20.2983 7.40051 20.3219 7.67004 20.1802L12.0001 17.9038L16.3302 20.1802C16.5998 20.3219 16.9264 20.2983 17.1727 20.1193C17.4191 19.9404 17.5425 19.637 17.491 19.3369L16.664 14.5154L20.1671 11.1007C20.3852 10.8882 20.4637 10.5703 20.3696 10.2807C20.2755 9.99104 20.0251 9.77997 19.7237 9.73618L14.8826 9.03272L12.7175 4.64594C12.5828 4.37288 12.3046 4.2 12.0001 4.2C11.6956 4.2 11.4175 4.37288 11.2827 4.64594L9.1177 9.03272L4.27652 9.73618C3.97517 9.77997 3.72481 9.99104 3.63071 10.2807C3.53661 10.5703 3.61509 10.8882 3.83315 11.1007L7.33626 14.5154L6.50929 19.3369Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path></svg>`;
    }

    return HTML;
}

// append reviews for slider
async function sliderReviews(page) {
    let response = await fetch(`https://api-cdn.yotpo.com/v1/widget/D9LZolxeDIeQPdn40QfzQVtXIZvRFPJxqhQThc1b/products/3590230671444/reviews?per_page=100&page=${page}`)
        .then(response => response.json());
    let yotpo = response.response;

    // create array to append softness reviews to
    let softnessReviews = [];

    // counter for number of reviews found
    let numReviews = 0;


    // if no reviews, leave
    if (yotpo.reviews.length === 0) {
        return;
    }

    // get the reviews that mention "softness" within the first 110 reviews

    for (let i = 0; i < yotpo.reviews.length; i++) {
        if ((yotpo.reviews[i].content.toLowerCase().includes("softness") || yotpo.reviews[i].content.toLowerCase().includes("soft")) && numReviews < 10) {
            numReviews = i + 1;
            softnessReviews.push(yotpo.reviews[i]);
        }
    }

    // reset containers
    /*
    document.querySelector("#productV2Slider #productV2SliderReviewsInner").innerHTML = "";

    // append in range
    for (let i = 0; i < softnessReviews.length; i++) {
        document.querySelector("#productV2Slider #productV2SliderReviewsInner").insertAdjacentHTML("beforeend", `
            <div class="productV2SliderReviewsItem">
                <div class="productV2SliderReviewsItemTop">
                    <div class="productV2SliderReviewsItemCustomer">
                        <span class="productV2SliderReviewsItemCustomerInitial">
                            ${softnessReviews[i].user.display_name.substring(0, 1).toUpperCase()}
                        </span>
                        <div class="productV2SliderReviewsItemCustomerName">
                           ${softnessReviews[i].user.display_name}
                            <span>Verified Buyer</span>
                        </div>
                    </div>
                    <div class="productV2SliderReviewsItemStars">
                       ${stars(softnessReviews[i].score)}
                    </div>
                </div>
                <div class="productV2SliderReviewsItemBottom">
                    <div class="productV2SliderReviewsItemTitle">
                        ${softnessReviews[i].title}
                    </div>
                    <div class="productV2SliderReviewsItemReview">
                        ${softnessReviews[i].content}
                    </div>
                </div>
            </div>
            `);
    }
     */
}


/***************************************** Rolls *****************************/

// rolls change event
document.querySelectorAll(".productV2FormRollsItem").forEach(function (element) {
    element.addEventListener("click", function () {
        let variant = this.getAttribute("variant");
        // change active product form
        document.querySelectorAll(".productV2Form.active").forEach(item => item.classList.remove('active'));
        document.querySelector(`.productV2Form[variant="${variant}"]`).classList.add("active");

        // update the selected frequency
        document.querySelector(`.productV2Form[variant="${variant}"]`).querySelector('.productV2FormFrequencySelectOption.default')?.click();
        updateSavings(document.querySelector(`.productV2Form[variant="${variant}"] .productV2FormFrequencySelectLabel`).innerText);

        refreshForm();
    });
})

/***************************************** Frequency *****************************/

// frequency open
document.querySelectorAll(".productV2FormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            return;
        }

        // remove current frequency from dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            let currentSellingPlan = element.closest(".productV2FormFrequency").getAttribute("selling_plan");
            if (parseInt(element.getAttribute('selling_plan')) === parseInt(currentSellingPlan)) {
                element.classList.remove("active");
            }
        })

        // open dropdown
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productV2FormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productV2FormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");

        // re-add current frequency to dropdown
        document.querySelectorAll('.productV2FormFrequencySelectOption').forEach(function (element) {
            if (!element.classList.contains("active")) {
                element.classList.add("active");
            }
        })
    }
});

// frequency change
document.querySelectorAll(".productV2FormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productV2FormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productV2FormFrequencySelectLabel").innerHTML = this.innerHTML;
        updateSavings(this.querySelector("span").innerHTML);
    });
})

// frequency setup
// popular is the default
document.querySelector(".productV2Form.active .productV2FormFrequencySelectOption.default")?.click();

// update the savings per year for the subscription option based on the selected frequency
function updateSavings(cadence) {
    // get the cadence
    let cad = parseInt(cadence.match(/\d+/g)[0]);

    // get the active form
    let activeForm = document.querySelector('.productV2Form.active');

    // get the active form's price and compare price for subscription
    let price = activeForm.querySelector('.productV2FormPrice').dataset.subPrice;
    let comparePrice = activeForm.querySelector('.productV2FormPrice').dataset.price;

    // determine the difference in price between subscription and one time purchase
    let difference = (comparePrice - price) / 100;

    // determine how many times per year full deliveries can be made based on cadence
    let yearlyDeliveries = Math.floor((52 / cad));

    if (comparePrice) {
        // calculate savings per year and update the DOM
        let savings = difference * yearlyDeliveries;

        activeForm.querySelector('.productV2FormRowBenefitsSavings span').innerHTML = `Save $${savings} per year`;
    }
}

/**************************************** Upsell + ATC *************************************/

function refreshForm() {
    document.querySelector("#productV2ATC span").textContent = "Add to Cart";

    // check if sold out
    if (document.querySelector(".productV2Form.active.available")) {
        document.querySelector("#productV2ATC").classList.remove("disabled");
    } else {
        document.querySelector("#productV2ATC").classList.add("disabled");
    }
}

refreshForm();

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

document.querySelector("#productV2ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // exit if disabled
    if (this.classList.contains("disabled")) {
        return;
    }

    // collect formdata

    let uniqueId = Date.now(); // generate a unique id for this product to identify it in the cart

    let formData = {
        id: parseInt(document.querySelector(".productV2Form.active").getAttribute("variant")),
        quantity: 1,
        properties: {
            '_unique_id': uniqueId // Leading underscore hides this from the customer at checkout
        }
    };

    // Subscription
    if (document.querySelector(`.productV2FormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productV2Form.active .productV2FormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // // clear cart
    // await fetch("/cart/clear.js");

    // add to cart
    await addProduct(formData);

    // open cart
    await openCart(false);

    // stop loading
    this.classList.remove("loading");
});

/*********************************** Stars *************/

document.querySelector("#productV2Stars").addEventListener("click", function () {
    // show reviews modal
    document.querySelector('#reviewsWidget').showModal();
    // no scroll
    document.body.classList.add("noScroll");
});

// preselect url
(async function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preselect_index")) {
        document.querySelectorAll(".productV2Form.active .productV2FormRollsItem")[urlParams.get("preselect_index")]?.click();
    }
}());
